import { BookingPlatform } from '$houdini';

export const BOOKING_PLATFORM_FOR_WEB = {
	WEB_DESKTOP: BookingPlatform.WEB_DESKTOP,
	WEB_MOBILE: BookingPlatform.WEB_MOBILE,
	WEB_TABLET: BookingPlatform.WEB_TABLET,
} as const;

type BookingPlatformForWeb = (typeof BOOKING_PLATFORM_FOR_WEB)[keyof typeof BOOKING_PLATFORM_FOR_WEB];

export function getPlatform(): BookingPlatformForWeb {
	return isSmallDevice()
		? BookingPlatform.WEB_MOBILE
		: isLargeDevice()
			? BookingPlatform.WEB_DESKTOP
			: BookingPlatform.WEB_TABLET;
}

export const getBookingPlatform = getPlatform;

export function isSmallDevice(): boolean {
	if (typeof window === 'undefined') {
		return false; // Default to non-small device on server-side
	}
	return window.innerWidth <= 640; // TODO: vérifier avec l'équipe analytics et marketing
}

export function isLargeDevice(): boolean {
	if (typeof window === 'undefined') {
		return true; // Default to large device on server-side
	}
	return window.innerWidth > 1024; // TODO: vérifier avec l'équipe analytics et marketing
}
